// extracted by mini-css-extract-plugin
module.exports = {"container":"Donut__container__vXaxR"};